import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-yoga': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_summary_checkpoints_yoga~1
			funnel: {
				id: 'ob-female-yoga-summary-checkpoints',
				locale: ['en'],
			},
		},
	},
]

export default config
